import { type ProductOfDayDataType } from '@/common/types/contract';

import { getEndTimeFromNow } from '../date';

export const addExpiredAtField = (
  contract: ProductOfDayDataType,
): ProductOfDayDataType => ({
  ...contract,
  expiredAt: contract.expiredIn
    ? getEndTimeFromNow(contract.expiredIn * 1000)
    : undefined,
});
